import React from 'react'
import { connect } from 'react-redux'
import { Container, Form } from 'reactstrap'
import { getAllClubs } from '../../api/clubapi'
import { getBranches } from '../../api/productapi'
import PopupError from '../PopupError'
import PromoCode, { validator } from './PromoCode'
import * as Constants from '../../store/Constants'
import { createPromoCode, updateResponse } from '../../api/promoCodeApi'
import { Redirect } from 'react-router-dom'
import RequiredFieldNotation from '../utils/RequiredFieldNotation';

class PromoCodeCreate extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            clubLoaded: false,
            branchLoaded: false,
            promoCodeId: 0,
            promoCodeCode: '',
            name: '',
            branchId: '-1',
            branchName: '',
            clubId: '-1',
            clubName: '',
            startDate: '',
            endDate: '',
            isSingleUse: false,
            applyToPrimeMember: false,
            applyToEnrollFee: false,
            applyToAssoc: false,
            promoTypeCode: 'None',
            enrollFeePromoTypeCode: 'None',
            assocPromoTypeCode: 'None',
            fixedAmount: '',
            percentage: '',
            promoCodeNote: '',
            enrollFeeFixedAmount: '',
            enrollFeePercentage: '',
            enrollFeeWaived: '',
            assocFixedAmount: '',
            assocPercentage: '',
            assocFreeCount: '',
            promoCodeStatus: '',
            promoCodeProducts: [],
            applyToCart: false,
            validation: validator().valid(),
            error: false,
            errorMessage: [],
            readOnly: false,
            selectedPromoTypeCheckbox: 0,
            disableEnrollFeePromo: false,
            disableAssocPromo: false,
            disableAssocPromoByPrice: false,
            isWarning: false,
            sourceProducts: []

        }
    }



    componentDidMount() {
        if (this.props.clubs.length === 0) {
            this.props.getAllClubs(function (result, _this) { }, this, true)
        } else {
            if (this.props.clubs.length > 0) {
                this.setState((state, props) => ({ clubLoaded: true, clubId: props.clubs[0].clubId, clubName: props.clubs[0].name }))
            }
        }
        if (this.props.branches.length === 0) {
            this.props.getBranches(function (result, _this) { }, this)
        } else {
            if (this.props.branches.length === 1) {
                this.setState((state, props) => ({ branchLoaded: true, branchId: props.branches[0].branchId, branchName: props.branches[0].name }))
            } else {
                this.setState({ branchLoaded: true })
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.updateResult !== this.props.updateResult && this.props.updateResult) {
            const { data } = this.props.updateResult
            if (data.success) {
                this.setState({ promoCodeId: data.data.promoCodeId })
            } else {
                const errors = data.errors.map(e => e.message)
                this.setState({ error: true, errorMessage: errors, isWarning: false })
            }
            this.props.updateResponse('')
        }
        if (prevProps.clubs !== this.props.clubs) {
            if (this.props.clubs.length > 0) {
                this.setState((state, props) => ({ clubLoaded: true, clubId: props.clubs[0].clubId, clubName: props.clubs[0].name }))
            }
        }
        if (prevProps.branches !== this.props.branches) {
            if (this.props.branches.length === 1) {
                this.setState((state, props) => ({ branchLoaded: true, branchId: props.branches[0].branchId, branchName: props.branches[0].name }))
            } else {
                this.setState({ branchLoaded: true })
            }
        }
    }

    handleSubmit = e => {
        e.preventDefault()
        this.submit = true;
        const startDate = document.getElementById("startDate").value;
        const endDate = document.getElementById("endDate").value;
        this.setState({ startDate, endDate }, () => { this.createPromoCode() })
    }

    createPromoCode() {
        const validation = this.validate()
        if (validation.isValid) {
            const { ...promoCode } = this.state
            promoCode.clubId = +promoCode.clubId > 0 ? promoCode.clubId : null
            promoCode.branchId = +promoCode.branchId > 0 ? promoCode.branchId : null
            promoCode.assocPromoTypeCode = promoCode.assocPromoTypeCode !== Constants.promoTypeNone ? promoCode.assocPromoTypeCode : null
            promoCode.enrollFeePromoTypeCode = promoCode.enrollFeePromoTypeCode !== Constants.promoTypeNone ? promoCode.enrollFeePromoTypeCode : null
            promoCode.promoTypeCode = promoCode.promoTypeCode !== Constants.promoTypeNone ? promoCode.promoTypeCode : null
            promoCode.enrollFeePercentage = promoCode.enrollFeePromoTypeCode === Constants.promoTypeWaived ? promoCode.enrollFeeWaived : promoCode.enrollFeePercentage
            this.props.createPromoCode(promoCode)
        }
    }

    validate = _ => {
        if (this.submit) {
            if (this.state.selectedPromoTypeCheckbox === 0) {
                this.handleError(['At least one Discount Area checkbox must be checked '], false)
                return { isValid: false }
            }
            const validation = validator(this.state.applyToCart, this.state.promoTypeCode, this.state.enrollFeePromoTypeCode, this.state.assocPromoTypeCode).validate(this.state);
            this.setState({ validation });
            return validation
        } else {
            return { isValid: false }
        }
    }

    setSelectValue = (fieldKey, valueKey, fieldName, valueName) => this.setState({ [fieldKey]: valueKey, [fieldName]: valueName }, _ => this.validate())
    setFieldValue = (fieldName, value) => this.setState({ [fieldName]: value }, _ => this.validate())
    setPromoCodeProducts = value => this.setState({ promoCodeProducts: value.map(x => ({ productId: x })) }, _ => this.validate())
    setSourceProducts = value => this.setState({ sourceProducts: value }, _ => this.validate())
    setPromoTypeCode = (promoTypeCode) => {
        if (promoTypeCode === Constants.promoTypeFixedAmount)
            this.setState({ promoTypeCode, percentage: '', promoCodeNote: '' }, _ => this.validate())
        else if (promoTypeCode === Constants.promoTypePercentage)
            this.setState({ promoTypeCode, fixedAmount: '', promoCodeNote: '' }, _ => this.validate())
        else
            this.setState({ promoTypeCode, percentage: '', fixedAmount: '' }, _ => this.validate())
    }
    setEnrollFeePromoTypeCode = (enrollFeePromoTypeCode) => {
        if (enrollFeePromoTypeCode === Constants.promoTypeFixedAmount)
            this.setState({ enrollFeePromoTypeCode, enrollFeePercentage: '', enrollFeeWaived: '' }, _ => this.validate())
        else if (enrollFeePromoTypeCode === Constants.promoTypePercentage)
            this.setState({ enrollFeePromoTypeCode, enrollFeeFixedAmount: '', enrollFeeWaived: '' }, _ => this.validate())
        else
            this.setState({ enrollFeePromoTypeCode, enrollFeeWaived: '100', enrollFeePercentage: '', enrollFeeFixedAmount: '' }, _ => this.validate())
    }
    setAssocPromoTypeCode = (assocPromoTypeCode) => {
        if (assocPromoTypeCode === Constants.promoTypeFixedAmount)
            this.setState({ assocPromoTypeCode, assocPercentage: '', assocFreeCount: '' }, _ => this.validate())
        else if (assocPromoTypeCode === Constants.promoTypePercentage)
            this.setState({ assocPromoTypeCode, assocFixedAmount: '', assocFreeCount: '' }, _ => this.validate())
        else
            this.setState({ assocPromoTypeCode, assocPercentage: '', assocFixedAmount: '', assocFreeCount: '1' }, _ => this.validate())
    }
    updatePromoTypeSelected = (name, value) => {

        this.setState(
            (prev) => ({
                selectedPromoTypeCheckbox: value
                    ? prev.selectedPromoTypeCheckbox + 1
                    : prev.selectedPromoTypeCheckbox - 1
            })
        )
    }
    handleCancel = _ => this.props.route.history.goBack()
    handleError = (errors) => {
        this.setState({ error: true, errorMessage: errors })
    }
    closeModal = () => this.setState({ error: false })


    render() {
        if (this.state.promoCodeId)
            return <Redirect
                to={{
                    pathname: `/secure/promoCodeEdit/${this.state.promoCodeId}`,
                }}
            />;

        return <Container>
            <div className="card">
                <div className="card-header text-center">Add Promo Code</div>
                <div className="card-body fs-12">
                    {this.props.branches.length > 0
                        && this.props.clubs.length > 0
                        && this.state.clubLoaded
                        && this.state.branchLoaded && <Form>
                            <RequiredFieldNotation />
                            <PromoCode
                                promoCodeCode={this.state.promoCodeCode}
                                promoCodeId={this.state.promoCodeId}
                                name={this.state.name}
                                clubId={this.state.clubId}
                                branchId={this.state.branchId}
                                setSelectValue={this.setSelectValue}
                                clubs={this.props.clubs}
                                branches={this.props.branches}
                                startDate={this.state.startDate}
                                endDate={this.state.endDate}
                                isSingleUse={this.state.isSingleUse}
                                applyToPrimeMember={this.state.applyToPrimeMember}
                                applyToEnrollFee={this.state.applyToEnrollFee}
                                applyToAssoc={this.state.applyToAssoc}
                                promoTypeCode={this.state.promoTypeCode}
                                enrollFeePromoTypeCode={this.state.enrollFeePromoTypeCode}
                                assocPromoTypeCode={this.state.assocPromoTypeCode}
                                fixedAmount={this.state.fixedAmount}
                                percentage={this.state.percentage}
                                promoCodeNote={this.state.promoCodeNote}
                                enrollFeeFixedAmount={this.state.enrollFeeFixedAmount}
                                enrollFeePercentage={this.state.enrollFeePercentage}
                                enrollFeeWaived={this.state.enrollFeeWaived}
                                assocFixedAmount={this.state.assocFixedAmount}
                                assocPercentage={this.state.assocPercentage}
                                assocFreeCount={this.state.assocFreeCount}
                                readOnly={this.state.readOnly}
                                selectedPromoTypeCheckbox={this.state.selectedPromoTypeCheckbox}
                                sourceProducts={this.state.sourceProducts}
                                setFieldValue={this.setFieldValue}
                                setPromoTypeCode={this.setPromoTypeCode}
                                setEnrollFeePromoTypeCode={this.setEnrollFeePromoTypeCode}
                                setAssocPromoTypeCode={this.setAssocPromoTypeCode}
                                setPromoCodeProducts={this.setPromoCodeProducts}
                                setSourceProducts={this.setSourceProducts}
                                updatePromoTypeSelected={this.updatePromoTypeSelected}
                                promoCodeProducts={this.state.promoCodeProducts}
                                validation={this.state.validation}
                                applyToCart={this.state.applyToCart}
                                promoCodeStatus={this.state.promoCodeStatus}
                                disableAssocPromo={this.state.disableAssocPromo}
                                disableAssocPromoByPrice={this.state.disableAssocPromoByPrice}
                                disableEnrollFeePromo={this.state.disableEnrollFeePromo}
                                handleCancel={this.handleCancel}
                                handleSubmit={this.handleSubmit}
                                handleError={this.handleError} />
                        </Form>}
                </div>
                <PopupError
                    open={this.state.error}
                    onClose={this.closeModal}
                    onClick={this.closeModal}
                    errorMessage={this.state.errorMessage}
                    isWarning={this.state.isWarning} />
            </div>
        </Container>
    }
}

export default connect(
    state => ({
        branches: state.data.branches,
        clubs: state.data.clubs,
        updateResult: state.data.updateResult,
    }),
    dispatch => ({
        getBranches: (callback, context) => { dispatch(getBranches(callback, context)) },
        getAllClubs: (callback, context, onlyactive) => { dispatch(getAllClubs(callback, context, onlyactive)) },
        createPromoCode: (promoCode) => { dispatch(createPromoCode(promoCode)) },
        updateResponse: (response) => { dispatch(updateResponse(response)) },
    })
)(PromoCodeCreate)